import { RunningExperiments, useExperiments } from 'state/experiments';

export const useGetCartGestureEnabledExperiment = (skipExposureLogging = false) => {
  const { variant } = useExperiments();

  // meant to be assigned to gestureEnabled prop for cart
  return !variant(RunningExperiments.DisableCartBackGesture, 'treatment', { skipExposureLogging });
};
